import { enableScroll, stopScroll } from '../__utils/lockScroll';

const $ = jQuery.noConflict();

class MobileHeader {
    constructor(trigger = '.btn-hamburger', pbody = 'body', listParent = '.menu-item-has-children > a', linkBack = '.link-back') {
        this.trigger = trigger;
        this.pbody = pbody;
        this.listParent = listParent;
        this.linkBack = linkBack;
    }
    init() {
        $(this.trigger).on('click', this.setNavState);
        $(this.listParent).on('click', this.openMobileNavItems);
        $(this.pbody).on('click', this.linkBack, this.returnToPreviousMenu);
    }
    setNavState(e) {
        e.preventDefault();
        const body = $('body');
        if ($(this).hasClass('open')) {
            MobileHeader.hideWrapper(this, body);
        } else {
            MobileHeader.showWrapper(this, body);
        }
    }
    openMobileNavItems(e) {
        e.preventDefault();
        const currentSubmenu = $(this).parent().find('> .sub-menu');
        const activeLinkText = $(this).text();
        const listItemBack = '<li class="list-item-back"><button class="link-back"><span>' + activeLinkText + '</span></button></li>';
        $(this).addClass('active-menu');
        $('.menu-item-has-children > a').removeClass('non-active-menu');
        currentSubmenu.prepend(listItemBack);
    }
    returnToPreviousMenu() {
        const activeMenuItem = $(this).closest('.menu-item-has-children');
        const activeMenuLink = activeMenuItem.find('> a');
        activeMenuLink.removeClass('active-menu');
        activeMenuLink.addClass('non-active-menu');
        $(this).parent().remove();
    }
    static hideWrapper(el, body) {
        const activeMenus = $('.main-header__nav-mobile').find('.active-menu');
        const listItemBack = $('.list-item-back');
        const mainHeader = $('.main-header');
        
        $(el).removeClass('open');
        body.removeClass('overlayed');
        $(el).next().removeClass('active');
        activeMenus.removeClass('active-menu');
        listItemBack.remove();
        if($(window).scrollTop() > 0) {
            $(mainHeader).addClass('main-header--sticky');        
        }
        enableScroll();
    }
    static showWrapper(el, body) {
        $(el).addClass('open');
        body.addClass('overlayed');
        $(el).next().addClass('active');
        const mainHeader = $('.main-header');
        if(mainHeader.hasClass('main-header--sticky')) {
            mainHeader.removeClass('main-header--sticky');
        } 
        stopScroll();
    }
    resized() {
        
        if (!$(this.trigger).is(':visible') && $(this.trigger).hasClass('open')) {
            MobileHeader.hideWrapper(this.trigger, $(this.pbody));
        }
    }
    hideOutsideClick(e) {
        if ($(this.trigger).length > 0 && $(this.trigger).hasClass('open')) {
            const container = $('.main-header');
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                MobileHeader.hideWrapper(this.trigger, $(this.pbody));
            }
        }
    }
    setProperMenuHeight() {
        const windowHeight = window.innerHeight + 'px';
        $('.main-header__nav-mobile--wrapper').css('height', windowHeight);
    }
}

export default MobileHeader;
